import React, { FunctionComponent } from 'react';
import { Box } from 'rebass/styled-components';
import theme from 'styled-theming';
import styled from 'styled-components';
import { ReactComponent as NewTagSvg } from '../assets/new-tag.svg';

export interface NewTagProps {
  testId?: string;
}

const newTagColor = theme('mode', {
  light: (props: any) => props.theme.colors.white,
  dark: (props: any) => props.theme.colors.blackRussian,
});

const NewTagWrapper = styled(Box)`
  color: ${newTagColor}
`;

const NewTag: FunctionComponent<NewTagProps> = ({
  testId,
}: NewTagProps) => (
  <NewTagWrapper><NewTagSvg data-testid={`new-tag${testId ? `-${testId}` : ''}`} /></NewTagWrapper>
);

export default NewTag;
